import { Controller } from "@hotwired/stimulus";

 // HTML with scrollTo action
 // <a href="#" data-action="click->scroll#scrollTo" data-target="section-id">
 //   Scroll to Section
 // </a>
 // <section id="section-id">Content here</section>

export default class extends Controller {
  static targets = [ "availability" ]
  connect() {
    // console.log("Hello, Stimulus!", this.element)
  }
  
  scrollTo(event) {
    
    event.preventDefault();

    const targetId = event.currentTarget.dataset.target;
    const targetElement = document.getElementById(targetId);
    console.log("Scrolling to", targetId);

    if (targetElement) {
      const y = targetElement.getBoundingClientRect().top + window.scrollY - 100;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }
  
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  // Scroll a specific element to top (useful for drawer frames)
  scrollElementToTop(event) {
    const element = event.target.closest('[data-scroll-target]');
    if (element) {
      const targetSelector = element.dataset.scrollTarget;
      const scrollElement = document.querySelector(targetSelector);
      if (scrollElement) {
        scrollElement.scrollTop = 0;
      }
    }
  }
}
